import { render, staticRenderFns } from "./DataUpload.vue?vue&type=template&id=3abcbc07&scoped=true&"
import script from "./DataUpload.vue?vue&type=script&lang=js&"
export * from "./DataUpload.vue?vue&type=script&lang=js&"
import style0 from "./DataUpload.vue?vue&type=style&index=0&id=3abcbc07&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abcbc07",
  null
  
)

export default component.exports